import { useLocation } from 'react-router-dom';
import { getPartOfCurrentQueryString } from 'helpers/getPartOfCurrentQueryString';
import { combineQueryStrings } from 'helpers/combineQueryStrings';
import { QueryParams, RoutePaths } from 'types/enums';
import { Tags } from 'types/enums/tags';

type BrowseLinkProps = { showFreeOnly: boolean };

export const useBrowseLink = (options?: BrowseLinkProps): string => {
    const { search } = useLocation();

    const currentQueryString = getPartOfCurrentQueryString({
        routerQueryString: search,
        queriesToExclude: [
            QueryParams.search,
            QueryParams.type,
            QueryParams.page,
        ],
    });

    const newFilterQuery = combineQueryStrings(
        currentQueryString,
        options?.showFreeOnly ? `tags=${Tags.Free}&Type=loop` : `Type=loop`,
    );

    return `/${RoutePaths.Browse}?${newFilterQuery}`;
};
